module.exports = __webpack_public_path__ + "static/img/电话按钮.f80e6e29.png";